import React from "react";

const SoundEngineeringMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src="https://sunrisingcinevisionacademy.com/public/assets/images/sound-engineering.jpg" alt="Sound Engineering" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Sound Engineering with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, one of the best film schools, offers a structured Sound Engineering Course for aspiring audio professionals. Whether you're looking for Sound Engineering Courses in Jaipur or want to master advanced audio production techniques, this program covers everything from fundamental acoustics to advanced sound design. Gain hands-on experience with industry-standard software and equipment while learning from experienced professionals to build a successful career in sound engineering.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">Course Overview</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li><strong>Level:</strong> Beginner to Advanced</li>
              <li><strong>Duration:</strong> 12-24 weeks</li>
              <li><strong>Certification:</strong> Certificate in Sound Engineering</li>
              <li><strong>Career Paths:</strong> Sound Engineer, Audio Technician, Mixing and Mastering Engineer, Post-Production Audio Engineer, Live Sound Engineer</li>
            </ul>
            <h2 className="text-xl font-bold mb-2 mt-5 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Core principles of Sound Engineering and audio production</li>
              <li>Mastering industry-standard software like Pro Tools, Logic Pro X, and Ableton Live</li>
              <li>Recording, mixing, and mastering techniques</li>
              <li>Live sound reinforcement and post-production audio editing</li>
              <li>Advanced sound processing and immersive audio techniques</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 1: Introduction to Sound Engineering</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Overview of Sound Engineering Courses and careers</li>
              <li>History of sound engineering</li>
              <li>Role of a sound engineer in different industries</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 2: Acoustics and Psychoacoustics</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Principles of acoustics and sound wave propagation</li>
              <li>Human hearing and perception</li>
              <li>Studio acoustics and soundproofing</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 3: Audio Signal Flow and Gain Staging</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Understanding signal flow and gain structure</li>
              <li>Audio interfaces, converters, and routing</li>
              <li>Cable management and troubleshooting</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 4: Microphones and Mic Techniques</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Microphone types and characteristics</li>
              <li>Mic placement for different instruments and vocals</li>
              <li>Wireless and boom microphone techniques</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 5: Consoles and Mixing</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Analog vs. digital mixing consoles</li>
              <li>Mixing techniques and signal routing</li>
              <li>Creating balanced mixes with EQ, compression, and effects</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 6: Digital Audio Workstations (DAWs)</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Hands-on training with Pro Tools, Logic Pro X, and Ableton Live</li>
              <li>DAW navigation, recording, and editing techniques</li>
              <li>MIDI programming and virtual instruments</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 7: Audio Processing and Effects</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Equalization (EQ), compression, and reverb</li>
              <li>Time-based effects and dynamics processing</li>
              <li>Using plug-ins and outboard gear for audio enhancement</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 8: Live Sound Reinforcement</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Setting up live sound systems</li>
              <li>Speaker and amplifier selection</li>
              <li>Soundcheck, system tuning, and real-time mixing</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 9: Post-Production Audio</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Film and TV audio post-production techniques</li>
              <li>Dialogue editing, ADR, and Foley sound</li>
              <li>Surround sound mixing and immersive audio</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Module 10: Advanced Sound Engineering Techniques</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Advanced mixing and mastering workflows</li>
              <li>3D and spatial audio techniques</li>
              <li>Career paths and industry networking opportunities</li>
            </ul>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Faculty</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Experienced sound engineers and audio professionals</li>
                <li>Industry leaders from music, film, and TV production</li>
              </ul>
              <h3 className="uppercase tracking-wide text-xl font-bold mt-6 text-[#A14D1F]">Guest Lectures</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Renowned sound engineers and music producers</li>
                <li>Experts in post-production, live sound, and immersive audio</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Practical Experience</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Hands-on Sound Engineering Courses in Jaipur with real-world projects</li>
                <li>Recording, mixing, and mastering music tracks</li>
                <li>Live sound setups for concerts and events</li>
                <li>Audio post-production for short films and TV projects</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Software, Equipment, Certification, Partnerships */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Software and Equipment</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Pro Tools</li>
              <li>Logic Pro X</li>
              <li>Ableton Live</li>
              <li>Analog and digital mixing consoles</li>
              <li>Professional microphones and outboard gear</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certification & Career Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Sound Engineering upon course completion</li>
              <li>Career opportunities in film, TV, music production, and live events</li>
            </ul>
            <h3 className="uppercase tracking-wide text-xl font-bold mt-6 text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Audio Engineering Society (AES)</li>
              <li>National Association of Broadcasters (NAB)</li>
              <li>Society of Broadcast Engineers (SBE)</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Take the Next Step in Your Sound Engineering Career</h3>
          <p className="mb-6 text-gray-700">
            Enroll in the Sound Engineering Course at Sunrising Cinevision Academy and gain the skills needed to succeed in the competitive audio industry. Whether you're looking for Sound Engineering Courses in Jaipur or want to specialize in post-production, live sound, or music production, this course provides the practical training and industry connections to advance your career.
          </p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default SoundEngineeringMain;
